export default __webpack_public_path__ + "static/michael_shtelma-351347795a588bbcb8ca8d6540e63a88.jpg";